<template>
  <div class="screen-module-head flex row-between">
    <div class="flex">
      <img v-if="titleIcon" :src="titleIcon" class="title-icon" />
      <div class="title-text">{{ titleText }}</div>
      <span v-if="description" class="info-icon" @click="onInfoClick" title="查看说明">
        <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
        </svg>
      </span>
    </div>
    <div v-if="tabs && tabs.length" class="flex time-tabs">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        class="tab-item"
        :class="{ active: currentPeriod === tab.value }"
        @click="onTabClick(tab.value)"
      >
        {{ typeof tab === 'string' ? tab : (tab.label || tab.text) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScreenModuleHead',
  props: {
    titleIcon: { type: String, default: '' },
    titleText: { type: String, default: '' },
    description: { type: String, default: '' },
    tabs: { type: Array, default: () => [] },
    value: { type: Number, default: 0 }
  },
  data() {
    return {
      currentPeriod: this.value
    }
  },
  watch: {
    value(val) {
      this.currentPeriod = val
    }
  },
  methods: {
    onTabClick(index) {
      this.currentPeriod = index
      this.$emit('input', index)
      this.$emit('change', index)
    },
    onInfoClick() {
      this.$alert(this.description, '', {
        confirmButtonText: '确定',
        customClass: 'screen-info-modal',
        dangerouslyUseHTMLString: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.screen-module-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;

  .flex {
    display: flex;
    align-items: center;
  }

  .title-icon {
    width: 24px;
    height: 24px;
  }

  .title-text {
    font-size: 16px;
    padding-left: 8px;
    line-height: 24px;
    color: #ffffff;
  }

  .info-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    min-width: 20px;
    flex-shrink: 0;
    margin-left: 4px;
    color: #9292C1;
    cursor: pointer;
    transition: color 0.2s;

    &:hover {
      color: #ffffff;
    }

    svg {
      width: 16px;
      height: 16px;
    }
  }

  .time-tabs {
    gap: 14px;
    display: flex;

    .tab-item {
      color: #ffffff;
      font-size: 12px;
      width: 36px;
      height: 18px;
      border-radius: 18px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &.active {
        background: #5a5a89;
      }
    }
  }
}
</style>
